import { Component, inject, input } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { HlmIconComponent } from '../../ui/icon.component';
import { HlmBtnDirective } from '../../ui/button.directive';

/**
 * EB-3775 — Access denied screen. Rendered by the root shell `@switch`
 * when `AuthService.accessState()` is `denied` or `denied-error`.
 * Variant `service-error` shows a Retry button (reloads the page) to
 * recover from transient `/userdetails` outages.
 */
@Component({
  selector: 'cmt-access-denied',
  standalone: true,
  imports: [HlmIconComponent, HlmBtnDirective],
  templateUrl: './access-denied.component.html',
})
export class AccessDeniedComponent {
  readonly variant = input<'no-role' | 'service-error'>('no-role');

  private readonly document = inject(DOCUMENT);

  retry(): void {
    this.document.defaultView?.location.reload();
  }
}
